export const categoriesMap = {
  "Mens Singles": "Singolare",
  "Womens Singles": "Singolare",
  "Mens Doubles": "Doppio",
  "Womens Doubles": "Doppio",
};

export const cagetoriesMapGranSlam = {
  "Mens Singles": "Singolare Maschile",
  "Womens Singles": "Singolare Femminile",
  "Mens Doubles": "Doppio Maschile",
  "Womens Doubles": "Doppio Femminile",
  "Mixed Doubles": "Doppio Misto",
};

export const isSingles = (category: string): boolean => category.toLowerCase().includes('singles');
